export const sources={};export const img={src:"__VITE_ASSET__aKo4wVjMjV9S8rY28E5Mvg__",w:640,h:640};export default{sources:sources,img:img};